import { isCrediMart } from "./helper";

export const getStaticImage = (imageFile: string) => {
  if (isCrediMart()) return `/img/credimart/${imageFile}`;
  return `/img/credistore/${imageFile}`;
};
